import { ITitle } from "@/shared/interfaces/ReUsedComponentsProps";

import "./Title.scss";

const tagClassMap = {
    h1: "headline_1",
    h2: "headline_2",
    h3: "headline_3",
    h4: "headline_4",
};

export default function Title({ tag, text, style, span, onClick  }: ITitle) {
    const Tag = tag;
    const tagClassName = tagClassMap[tag] || "";

    return (
        <Tag
            className={`${tagClassName} title ${span ? "isSpanText" : ""}`}
            style={style}
            onClick={onClick}
        >
            {text}
            {span && <span className='right-text'>{span}</span>}
        </Tag>
    );
}
